import React, { useState, useEffect } from "react";
import Button from "antd/lib/button";
import Upload from "antd/lib/upload";
import UploadOutlined from "@ant-design/icons/UploadOutlined";
import { array, func } from "prop-types";
import "./upload.module.scss";

const UploadFile = ({
  fileList,
  setFileList,
  idDoc
}) => {
  const [file, setFile] = useState(null)
  
  useEffect(() => {
    setFile(fileList.find(file => file.idDoc === idDoc))
  }, [fileList]);
  
  const onRemove = (file) => {
    const index = fileList.indexOf(file);
    const newFileList = [...fileList];
    newFileList.splice(index, 1);
    setFileList(newFileList);
  };
  
  const beforeUpload = (file) => {
    const tempFileList = [...fileList]
    tempFileList.push({file, idDoc})
    setFileList(tempFileList);
    return false;
  };

  return (
    <div className="containerButtonUpload">
      <Upload
        file={file}
        onRemove={onRemove}
        beforeUpload={beforeUpload}
      >
        <Button className="uploadButton" disabled={file}>
          <UploadOutlined /> Parcourir
        </Button>
      </Upload>
    </div>
  );
};

UploadFile.propTypes = {
  fileList: array,
  setFileList: func
};

export default UploadFile;
